import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import {useSelector} from 'react-redux';
import {
  hybridHoldExpiresAt,
  isHybridBookingPending,
  isHybridHoldRunning
} from 'helpers/functionUtils/hybridDelivery';
import useCountdown from 'routes/App/ordersV2/OrderDetails/DriverOptOut/useCountdown';
import DriverOptOutAction from 'routes/App/ordersV2/OrderDetails/DriverOptOut/DriverOptOutAction';
import {
  DriverOptOutContent,
  DriverOptOutCountdown,
  DriverOptOutTitle,
  DriverOptOutWrap
} from 'routes/App/ordersV2/OrderDetails/DriverOptOut/styles';

const DriverOptOut = ({order, onSwitched}) => {
  const serviceFeatures = useSelector(
    (state) => state.user?.activeLocation?.AllowedServiceFeatures
  );
  const {seconds, label} = useCountdown(hybridHoldExpiresAt(order));

  const isRunning = isHybridHoldRunning(order, serviceFeatures) && !!seconds;
  // Stays mounted through the booking window so a request fired in the last
  // seconds still has somewhere to report its failure.
  if (!isRunning && !isHybridBookingPending(order, serviceFeatures)) {
    return null;
  }

  return (
    <DriverOptOutWrap className={cn({onlyAction: !isRunning})}>
      <DriverOptOutAction
        order={order}
        onSuccess={onSwitched}
        canSwitch={isRunning}
        className='ButtonMedium solid'
      />
      {isRunning && (
        <DriverOptOutContent>
          <DriverOptOutTitle>
            Sauce driver assigned in{' '}
            <DriverOptOutCountdown>{label}</DriverOptOutCountdown>
          </DriverOptOutTitle>
        </DriverOptOutContent>
      )}
    </DriverOptOutWrap>
  );
};

DriverOptOut.propTypes = {
  order: PropTypes.shape({}).isRequired,
  onSwitched: PropTypes.func.isRequired
};

export default DriverOptOut;
